import { EnumValue, isArray } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { validatePayload } from '../../utils/validate-payload.js';
import { SortBy } from './criteria.js';
const criterionDefinition = {
    by: new EnumValue({ enum: SortBy, required: true }),
};
export const registerSortCriterion = createAction('sortCriteria/register', (payload) => validate(payload));
export const updateSortCriterion = createAction('sortCriteria/update', (payload) => validate(payload));
const validate = (payload) => {
    if (isArray(payload)) {
        payload.forEach((p) => validatePayload(p, criterionDefinition));
        return { payload };
    }
    return validatePayload(payload, criterionDefinition);
};
